import {
  AfterViewInit,
  Directive,
  ElementRef,
  HostListener,
  Input,
  Renderer2,
} from '@angular/core';

@Directive({
  selector: '[matBounceButton]',
})
export class MatBounceButtonDirective implements AfterViewInit {
  @HostListener('window:resize')
  onWindowResize(): void {
    this.resizeHandler();
  }
  // Input points to wrapping element / element with base width
  @Input() matBounceButton: HTMLDivElement;

  private buttonLabelWrapper: HTMLElement;
  private isBouncing: boolean;
  private buttonWidth: number;
  private animation: Animation;

  constructor(private elRef: ElementRef, private renderer: Renderer2) {}

  ngAfterViewInit(): void {
    this.resizeHandler();
  }

  private resizeHandler(): void {
    // Timeout required to capture updated width
    setTimeout(() => {
      const wrapperWidth = this.matBounceButton.offsetWidth;
      if (!this.buttonWidth) {
        this.buttonWidth = this.elRef.nativeElement.offsetWidth;
      }
      if (wrapperWidth < this.buttonWidth) {
        this.animateButton(wrapperWidth, this.buttonWidth);
        this.isBouncing = true;
      }
      if (wrapperWidth > this.buttonWidth && this.isBouncing) {
        this.setDefaultDisplay();
        this.isBouncing = false;
      }
    }, 0);
  }

  private animateButton(wrapperWidth: number, buttonWidth: number): void {
    if (!this.buttonLabelWrapper) {
      this.assignButonLabelWrapper();
    }

    this.renderer.setStyle(this.elRef.nativeElement, 'width', `${wrapperWidth}px`);
    this.renderer.setStyle(this.elRef.nativeElement, 'overflow', `hidden`);
    this.renderer.setAttribute(this.elRef.nativeElement, 'button-bounce', '');

    this.animation = this.buttonLabelWrapper.animate(
      [
        { transform: 'translateX(0%)' },
        { transform: `translateX(${wrapperWidth - buttonWidth}px)` },
      ],
      {
        duration: this.getOptimalAnimationDuration(wrapperWidth, buttonWidth),
        easing: 'linear',
        direction: 'alternate',
        // I couldn't find way to set it as infinite
        iterations: 999999,
        fill: 'both',
      }
    );
  }

  private assignButonLabelWrapper(): void {
    const buttonChildren: HTMLElement[] = Array.from(this.elRef.nativeElement.children);
    this.buttonLabelWrapper = buttonChildren.find(
      (element: HTMLElement) => (element.className = '.mat-button-wrapper')
    );
  }

  private getOptimalAnimationDuration(wrapperWidth: number, buttonWidth: number): number {
    const widthDifference = buttonWidth - wrapperWidth;
    const msPerPixel = 24;
    const optimalAnimationDuration = widthDifference * msPerPixel;

    // Prevent from too rapid animations
    return optimalAnimationDuration > 600 ? widthDifference * msPerPixel : 600;
  }

  private setDefaultDisplay(): void {
    this.renderer.setStyle(this.elRef.nativeElement, 'width', 'initial');
    this.renderer.setStyle(this.elRef.nativeElement, 'overflow', 'initial');
    this.renderer.setAttribute(this.elRef.nativeElement, 'button-bounce-off', '');
    this.renderer.removeAttribute(this.elRef.nativeElement, 'button-bounce', '');
    this.animation.cancel();
  }
}
